import React from 'react'
import i18next from 'i18next'
import { Dropdown, DropdownButton, Form } from 'react-bootstrap'

const { t } = i18next

class CheckboxFilter extends React.PureComponent {
  static defaultProps = {
    type: 'checkbox',
    label: '',
    items: [],
    filteredItems: [],
    onChangeFilter: () => null,
    disabled: false,
    className: '',
    showSearch: false,
  }

  state = {
    search_filter: '',
  }

  handleChange = id => e => {
    let filtered_items = [...this.props.filteredItems]
    if (this.props.type === 'checkbox') {
      if (id === 0) {
        filtered_items = filtered_items.length !== this.props.items.length ? this.props.items.map(r => r.id) : []
      } else {
        if (filtered_items.includes(id)) {
          filtered_items = filtered_items.filter(_id => _id !== id)
        } else {
          filtered_items.push(id)
        }
      }
    } else {
      filtered_items = [id]
    }

    this.props.onChangeFilter(filtered_items)
    e.stopPropagation()
  }

  onChangeSearchFilter = ({ target: { value } }) => {
    this.setState({ search_filter: value.replace(/[.*?^$]+/, '') })
  }

  searchFilter = search_filter => {
    let { items: all_items } = this.props
    let items = all_items
    let regexp = new RegExp(`.*${search_filter ? search_filter : ''}.*`, 'i')
    items = items.filter(e => {
      let name = `${e.name}`
      return regexp.test(name)
    })
    return items
  }

  nullHandler = () => null

  render() {
    // eslint-disable-next-line
    let { type, label, items, filteredItems, disabled, className, onChangeFilter, showSearch, ...rest } = this.props
    let filtered_items = showSearch === true ? this.searchFilter(this.state.search_filter) : items
    return (
      <>
        <style jsx="true">
          {className.includes('w-100')
            ? `
            .dropdown .btn,
            .dropdown .dropdown-menu {
              width: 100% !important;
            }
          `
            : ''}
        </style>
        <DropdownButton align="start" className={className} title={label} disabled={disabled} {...rest}>
          {showSearch === true && (
            <Form.Group className="mb-2 p-2">
              <Form.Control
                name="search_filter"
                placeholder={t('checkbox_filter.search', 'Cerca')}
                value={this.state.search_filter}
                onChange={this.onChangeSearchFilter}
              />
            </Form.Group>
          )}
          <div className="items" style={{ maxHeight: '24rem', overflow: 'auto' }}>
            {filtered_items.map((item, i) => {
              return (
                <Dropdown.Item
                  key={`role-${item.id}-${i}`}
                  className="d-flex gap-3 align-items-center"
                  onClick={this.handleChange(item.id)}>
                  <Form.Check
                    role="button"
                    type={type}
                    id={item.id}
                    value={item.id}
                    name={item.name}
                    checked={filteredItems.includes(item.id)}
                    onChange={this.nullHandler}
                    className="pe-none"
                  />
                  <label htmlFor={item.id} role="button" className="mb-0 d-flex align-items-center gap-2">
                    {/* 🔷 Quadrato colorato */}
                    {item.color && (
                      <span
                        style={{
                          width: '12px',
                          height: '12px',
                          backgroundColor: item.color,
                          display: 'inline-block',
                          borderRadius: '2px',
                        }}
                      />
                    )}

                    {item.name}
                    {item.enabled === false && <i className="fas fa-ban text-danger ms-1" />}
                  </label>
                </Dropdown.Item>
              )
            })}
          </div>
          {type === 'checkbox' && (
            <>
              <Dropdown.Divider />
              <Dropdown.Item key={`all`} className="d-flex gap-3 align-items-center" onClick={this.handleChange(0)}>
                <Form.Check
                  role="button"
                  id={0}
                  value={0}
                  name={'all'}
                  checked={this.props.items.length === filteredItems.length}
                  onChange={this.nullHandler}
                  className="pe-none"
                />
                <label htmlFor={'all'} role="button">
                  {this.props.items.length === filteredItems.length &&
                    t('system_wide.checkbox_filter.deselect_all', 'Deseleziona tutti')}
                  {this.props.items.length > filteredItems.length &&
                    t('system_wide.checkbox_filter.select_all', 'Seleziona tutti')}
                </label>
              </Dropdown.Item>
            </>
          )}
        </DropdownButton>
      </>
    )
  }
}

export default CheckboxFilter
